export default {
	"roads": {
		"mobile": "手机号",
		"executionHandle": "查看执行情况",
		"deliveryExecution": "配送执行情况",
		"billPayable": "应付账单",
		"routerNoDataRange": "请输入派车单号或者选择创建时间范围"
	},
	"roadsMultiple": {
		"waybillDetails": "运单明细",
		"actualGoodsQty": "实提货品数量",
		"finishTransportQty": "完成运单数",
		"actualTonKm": "实际吨公里",
		"actualFullLoadRatio": "实际满载率",
		"stayPointInformation": "停留点信息",
		"roadsmultiple": "里程",
		"latestReceiverStation": "最近送货点",
		"transitTime": "运输时间",
		"senderAddressTips": "允许输入地址选择"
	},
	"roadsSingle": {
		"actualTime": "实际用时"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/roads/roads.js